"use client";

import Link from "next/link";
import { PeekIcon } from "@/components/icons/peek-icon";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

export function Logo() {
  const [isPeak, setIsPeak] = useState(false);
  const [isChanging, setIsChanging] = useState(false);

  useEffect(() => {
    const toggleName = () => {
      // Signal the change is happening
      setIsChanging(true);

      // Change the name
      setTimeout(() => {
        setIsPeak((prev) => !prev);
      }, 100);

      // End the change signal
      setTimeout(() => {
        setIsChanging(false);
      }, 600);

      // Schedule next toggle randomly 10+ sec
      const nextToggleDelay = 10000 + Math.random() * 5000;
      setTimeout(toggleName, nextToggleDelay);
    };

    // Initial delay before first toggle
    const initialDelay = setTimeout(toggleName, 16000);

    return () => {
      clearTimeout(initialDelay);
    };
  }, []);

  return (
    <Link
      href="/"
      className="flex items-center gap-2 hover:opacity-80 transition-opacity"
    >
      <PeekIcon
        className="h-8 w-8 lg:h-10 lg:w-10"
        isLookingAtText={isChanging}
      />
      <div className="flex flex-col leading-none">
        <span className="text-lg lg:text-xl font-bold tracking-tight inline-flex items-center">
          Pe
          <span className="relative inline-flex overflow-hidden">
            <span className="invisible" aria-hidden="true">e</span>
            <AnimatePresence initial={false} mode="popLayout">
              <motion.span
                key={isPeak ? "a" : "e"}
                initial={{ y: '-100%' }}
                animate={{ y: 0 }}
                exit={{ y: '100%' }}
                transition={{
                  duration: 0.4,
                  ease: 'linear',
                }}
                className="absolute inset-0 text-center"
              >
                {isPeak ? "a" : "e"}
              </motion.span>
            </AnimatePresence>
          </span>
          k Product
        </span>
        <span className="text-xs text-muted-foreground hidden sm:block">
          Открывайте стартапы каждую неделю
        </span>
      </div>
    </Link>
  );
}
